<template>
  <div class="RoleTreeBody">
    <el-tree
      check-strictly
      :default-expand-all="true"
      :data="treeData"
      show-checkbox
      check-on-click-node
      :expand-on-click-node="false"
      node-key="PowerId"
      ref="tree"
      :props="{ label: 'PowerName' }"
      @check="treeChange"
    ></el-tree>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      treeData: [],
    };
  },
  watch: {
    value: {
      handler(list) {
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys([...list]);
        });
      },
      immediate: true,
    },
  },
  mounted() {
    this.$get("Power/GetList", {
      IsEnable: "1",
    }).then((r) => {
      let treeData = this.$g.listToTree(r.Result, "PowerId", "PowerParent");
      this.treeData = treeData;
    });
  },
  methods: {
    treeChange(data, checked, indeterminate) {
      this.$emit("input", checked.checkedKeys);
    },
  },
};
</script>

<style lang="scss" scoped>
.RoleTreeBody {
  height: 400px;
  overflow-y: auto;
}
</style>